import { mapGetters } from 'vuex'

import { get } from 'lodash'

import { proxy } from '@/utils'

import { opfListShort } from '@/components/services/requisites/utils'

import render from './render'

export default {
  name: 'Form',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    isNew: Boolean
  },

  data() {
    return {
      vat: undefined,

      showFileManager: false
    }
  },

  computed: {
    ...mapGetters({
      file: 'file/file',
      uploadState: 'file/state'
    }),

    validation() {
      return Boolean(!!this.proxy.title && !!this.proxy.FileId)
    }
  },

  watch: {
    file: {
      handler(file) {
        this.showFileManager = false
        this.proxy.FileId = file.id
      },
      deep: true
    },

    validation() {
      this.$emit('validation', this.validation)
    },

    'proxy.OwnerId'() {
      this.proxy.RequisiteId = undefined
      this.proxy.CompanyId = undefined
    },

    'proxy.RequisiteId'() {
      this.proxy.CompanyId = undefined
    }
  },

  mounted() {
    this.$emit('validation', this.validation)
  },

  beforeDestroy() {
    if (this.isNew) {
      for (const key in this.proxy) {
        this.proxy[key] = undefined
      }
    }
  },

  methods: {
    getRequisiteOptionData(item) {
      const organizationalLegalForm = get(item, 'data.legal.opf')
      const legalName = get(item, 'data.legal.name')
      const vat = get(item, 'data.tax.vat')

      return {
        label: [ opfListShort[organizationalLegalForm], legalName ].filter(Boolean).join(' '),
        title: legalName,
        subtitle: organizationalLegalForm,
        vat
      }
    },

    getCompanyOptionData(item) {
      return {
        label: item.title,
        title: item.title,
        subtitle: undefined,
        vat: item.vat
      }
    }
  },

  render
}
